
<template>
  <div class="mark-detail-deal-wrap">
    <DetailPageWrap
      :description="describe"
      :titleCardOptions="cardOpt"
      v-loading="loading"
    >
      <template>
        <div class="card-wrap">
          <a-row :gutter="[8, 0]" type="flex">
            <a-col :span="18">
              <div class="result-wrap">
                <MediaWrap
                  class="audio-wrap"
                  :url="result.picture"
                  :width="230"
                  :height="230"
                ></MediaWrap>
                <div class="right-wrap">
                  <div class="head-wrap">
                    <div class="title">
                      <span>{{ result.patentName }}</span>
                      <span class="classicType"
                        >【{{ result.legalStatus }}】</span
                      >
                      <span class="classicType"
                        >【{{ result.patentTypeStr }}】</span
                      >
                    </div>
                    <!-- <div
                      class="favorite"
                      @click="(e) => handleCollect(e, result)"
                    >
                      <a-icon
                        type="star"
                        :theme="collectStatus"
                        :style="collectColor"
                      />
                      <span>{{ is_collect ? '已收藏' : '收藏' }}</span>
                    </div> -->
                  </div>
                  <span class="line"></span>
                  <div class="mark-card-body-wrap">
                    <div>申请号：{{ result.applyNum }}</div>
                    <div>公开(公告)号：{{ result.publicNum }}</div>
                    <div>法律状态：{{ result.legalStatus }}</div>
                    <div>
                      <span>运营类型：</span>
                      <span
                        class="dealType"
                        :style="{ background: colors[result.operationType] }"
                        >{{ result.operationTypeStr }}</span
                      >
                    </div>
                    <div>发布时间：{{ result.publishTime }}</div>
                    <div>
                      价格：<span class="price">{{
                        result.priceRange === -1
                          ? '面议'
                          : '￥' + result.priceRange
                      }}</span>
                    </div>
                  </div>
                  <!-- <a-button class="toDetailBtn" @click="goSearch(result)">查看详情</a-button> -->
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <SideWrap iconName="iconPhone.png" type="img" title="联系方式">
                <template>
                  <div class="side-body-wrap">
                    <div class="user-head">
                      <img src="/static/iconAvator.png" alt="" />
                    </div>
                    <div>联系人: {{ user.userName }}</div>
                    <div>电话: {{ user.enpPhone }}</div>
                    <div>邮箱: {{ user.email }}</div>
                  </div>
                </template>
              </SideWrap>
            </a-col>
          </a-row>
        </div>
      </template>

      <!-- 自定义插槽 -->
      <template slot="infos" slot-scope="{ instance }">
        <component
          :is="instance.componentName"
          :instance="instance"
          :publicNum="result.publicNum"
        ></component>
      </template>
    </DetailPageWrap>
  </div>
</template>

<script>
import DetailPageWrap from '@/components/common/DetailPageWrap'
import SideWrap from './components/SideWrap.vue'
import { searchInfoByPn } from '@/api/announceApi'
import { requestCols } from './config/cols'
import { describeConfig, key2label } from './config/key2label'
import { getLincenceDetailInfo, collectTradingInfo } from '@/api/tradingInfos.js'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { productDataBase } from '@/api/competitor'

// 插槽
import AssessmentResult from './components/AssessmentResult.vue'
import Infos from './components/Infos.vue'
import ClassInfo from './components/ClassInfo.vue'
import LawInfo from './components/LawInfo.vue'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: false,
      describeConfig, // 配置describe
      result: {},
      baseInfos: {},
      user: {},
      describe: [],
      collectStatus: 'outlined',
      collectColor: { color: '#364759' },
      colors: {
        0: '#89C997', // 转让
        1: '#6582FF', // 许可
        2: '#2279D2', // 质押
        3: '#FFC94D',
        4: '#fd9a00',
      },
      is_collect: false,
      cardOpt: {
        title: '开放许可',
      },
    }
  },
  components: {
    AssessmentResult,
    ClassInfo,
    Infos,
    LawInfo,
    DetailPageWrap,
    SideWrap,
  },
  created() {
    this.initDefaultValue()
  },
  methods: {
    goSearch(val) {
      productDataBase().then((res) => {
        const { access_token } = res.data
        const { refresh_token } = res.data
        window.open(
          `${window.APP_NAME.BASE_URL}?token=${access_token}&refresh_token=${refresh_token}&an=${val.applyNum}&pn=${val.publicNum}`
        )
        // window.open(`http://localhost:8083?token=${access_token}&refresh_token=${refresh_token}&an=${val.applyNum}&pn=${val.publicNum}`)
      })
    },
    async initDefaultValue() {
      try {
        this.loading = true
        const { id } = this.$route.query
        const { data } = await getLincenceDetailInfo(id)
        const row = this.handlerDateFormat([data])
        this.handlerResultMappings(row) // 处理数据的映射关系
        this.result = row[0]
        this.handleDetailByPn() // 处理通过公开号带出的详细信息
        this.handleCollectStatus()
        if (row[0].user !== null) {
          this.user = row[0].user
        }
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    async handleDetailByPn() {
      const { publicNum } = this.result
      try {
        this.detailLoading = true
        const { data } = await searchInfoByPn(publicNum, requestCols)
        const {
          result: [detailResult],
        } = JSON.parse(data)
        this.handleDescribeList(detailResult) // 处理基本信息
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.detailLoading = false
      }
    },
    // 处理开放许可中的基本信息
    handleDescribeList(result) {
      this.describeConfig.forEach((item) => {
        if (!item.content) return
        Object.keys(item.content).forEach((key) => {
          const k = key2label[key] // 获取映射
          let v = result[k]
          if (item.fromDetailApi) {
            // 不从一专利的search接口中取值
            v = this.result[k]
          }
          if (k === 'icnea4_stat') {
            // ipc分类号
            let suffix =
              result['icnea1_stat'] && result['icnea1_stat'].slice(0, 1)
            if (result[k] && Array.isArray(result[k])) {
              v = result[k].reduce((pre, k) => {
                pre.push(`${suffix}${k}`)
                return pre
              }, [])
            }
          }
          if (k === 'ipc_li') {
            if (result.ipc_main_stat && result.ipc_main_stat !== null) {
              let str = result.ipc_main_stat + '(主)'
              if (!v) {
                v = []
              }
              v.unshift(str)
            }
          }
          // cpc_fi
          if (k === 'cpc_li') {
            if (result.cpc_fi && result.cpc_fi !== null) {
              let str = result.cpc_fi
              if (!v) {
                v = []
              }
              v.unshift(str)
            }
            if (result.cpc_la && result.cpc_la !== null) {
              let str = result.cpc_la
              if (!v) {
                v = []
              }
              v.push(str)
            }
          }
          item.content[key] = v || '-'
        })
      })
      this.describe = this.describeConfig
    },
    // 处理用户的基本信息
    dealBaseInfo(result) {
      const info = result.patent
      if (!info) return
      const { applicants_stat, assignees, inventors, ...otherParams } = info
      this.baseInfos = {
        ...otherParams,
        applicants_stat: applicants_stat.join(','),
        assignees: assignees.join(','),
        inventors: inventors.join(','),
      }
    },
    async handleCollect(e, item) {
      e.stopPropagation()
      const { id, is_collect } = item
      if (is_collect) {
        const params = { collectId: id, params: { is_collect: '0' } }
        const { msg, code } = await collectTradingInfo(params)
        this.$apiStatusHandler(code, msg)
        if (code === 200) {
          this.initDefaultValue()
        }
        return
      }
      const params = { collectId: id, params: { is_collect: '1' } }
      const { msg, code } = await collectTradingInfo(params)
      this.$apiStatusHandler(code, msg)
      if (code === 200) {
        this.initDefaultValue()
      }
    },
    //收藏样式变化
    handleCollectStatus() {
      const { is_collect } = this.result
      if (is_collect) {
        this.collectStatus = 'filled'
        this.collectColor = { color: '#57b9fe' }
        this.is_collect = true
        return
      }
      this.collectStatus = 'outlined'
      this.collectColor = { color: '#364759' }
      this.is_collect = false
    },
  },
}
</script>
